import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { Customer, Employee } from "../http/http.service";
import { DespatchAdvice } from "../../../features/project/features/transport-management/services/transport-management-http.service";
import { BreadcrumbContext } from "../../types/navigation.type";
import { Project } from "../../types/sidebar.type";

@Injectable({ providedIn: "root" })

export class BreadcrumbHttpService {
  private _http: HttpClient = inject(HttpClient);

  public requests: Map<string, (url: string) => Observable<BreadcrumbContext>> = new Map<string, (url: string) => Observable<BreadcrumbContext>>([
    [ "api/projects/{projectNumber}", (url: string): Observable<BreadcrumbContext> => this.getProject(url) ],
    [ "api/transport-management/projects/{projectNumber}/despatch-advices/{despatchAdvisesNumber}", (url: string): Observable<BreadcrumbContext> => this.getDespatchAdvise(url) ],
    [ "api/equipment-management/projects/{projectNumber}/equipment-despatch-advices/{liftingEquipmentNumber}", (url: string): Observable<BreadcrumbContext> => this.getEquipmentDespatchAdvide(url) ],
    [ "api/customers/{customerNumber}", (url: string): Observable<BreadcrumbContext> => this.getCustomer(url) ],
    [ "api/customers/{customerNumber}/employees/{employeeNumber}", (url: string): Observable<BreadcrumbContext> => this.getEmployee(url) ],
    [ "api/access-control/projects/{projectNumber}/daily-identifications/{cardNumber}", (url: string): Observable<BreadcrumbContext> => this.getDID(url) ],
    [ "api/access-control/projects/{projectNumber}/visitor-identifications/{cardNumber}", (url: string): Observable<BreadcrumbContext> => this.getVID(url) ],
    [ "api/administration/authorization/users/{userId}", (url: string): Observable<BreadcrumbContext> => this.getSystemUser(url) ]
  ]);

  private getProject (url: string): Observable<BreadcrumbContext> {
    return this._http.get<Project>(url, { params: { expand: "DEFAULT" } }).pipe(
      map((project: Project) => ({ label: `${ project.number } ${ project.name }` }))
    );
  }

  private getDespatchAdvise (url: string): Observable<{
    label: string;
  }> {
    return this._http.get<DespatchAdvice>(url).pipe(
      map((despatchAdvise: DespatchAdvice) =>
      /* TODO: Klären was hier angezeigt werden soll */
        ({ label: `${ despatchAdvise.number } (${ despatchAdvise.recipient.customerNumber } ${ despatchAdvise.recipient.customerName })` }))
    );
  }

  private getEquipmentDespatchAdvide (url: string): Observable<{
    label: string;
  }> {
    return this._http.get<DespatchAdvice>(url).pipe(
      map((despatchAdvise: DespatchAdvice) =>
      /* TODO: Klären was hier angezeigt werden soll */
        ({ label: `${ despatchAdvise.number } (${ despatchAdvise.recipient.customerNumber } ${ despatchAdvise.recipient.customerName })` }))
    );
  }

  private getCustomer (url: string): Observable<{
    label: string;
  }> {
    return this._http.get<Customer>(url).pipe(
      map((customer: Customer) => ({ label: `${ customer.number } ${ customer.mainAddress.name1 }` }))
    );
  }

  private getEmployee (url: string): Observable<{
    label: string;
  }> {
    return this._http.get<Employee>(url, { params: { expand: "EXTENDED_DATA" } }).pipe(
      map((employee: Employee) => ({ label: `${ employee.number } ${ employee.fullName }` }))
    );
  }

  private getDID (url: string): Observable<{
    label: string;
  }> {
    return this._http.get<Employee>(url).pipe(map((employee: Employee) =>
    /* TODO: Backend soll hier fullName bereitstellen */
      ({ label: `${ employee.number } ${ employee.firstName } ${ employee.lastName }` })));
  }

  private getVID (url: string): Observable<{
    label: string;
  }> {
    return this._http.get<Employee>(url).pipe(map((employee: Employee) =>
    /* TODO: Backend soll hier fullName bereitstellen */
      ({ label: `${ employee.number } ${ employee.firstName } ${ employee.lastName }` })));
  }

  private getSystemUser (url: string): Observable<{
    label: string;
  }> {
    return this._http.get<Employee>(url).pipe(
      map((value: Employee) => ({ label: ` ${ value.firstName } ${ value.lastName }` }))
    );
  }
}
